import Vue from 'vue'
import deepEqual from 'deep-equal'  
import Component from 'vue-class-component'
import {VuetifyConfirmObject} from 'vuetify-confirm'

@Component({
  name: 'CheckUnsaveChange',   
})
export default class CheckUnsaveChange<T> extends Vue {  
  
  get original():T|null{
    return null
  }

  get modified():T|null{
    return null
  }

  get unsaveDialogMessage(){
    return this.$t('Admin.UnsaveDialogMessage').toString()
  }

  get unsaveDialogOptions():VuetifyConfirmObject{
      return {title: this.$t('Admin.Warning')} as VuetifyConfirmObject
  }

  beforeRouteUpdate (to:string, from:string, next:any) {     
    this.checkUnsaveObjectChange(next)
  }

  beforeRouteLeave (to:string, from:string, next:any) {        
    this.checkUnsaveObjectChange(next)    
  }

  checkUnsaveObjectChange(next:any){
    if(deepEqual(this.original,this.modified))
    {
      next()
    } 
    else{   
      this.$confirm(this.unsaveDialogMessage,this.unsaveDialogOptions).then((answer) => {
        if (answer) {
          next()
        } else {
          next(false)
        }
      })
    }    
  }
}